export const en = {
  common: {
    appName: 'SwapStop',
    search: 'Search',
    actions: 'Actions',
    status: 'Status',
    name: 'Name',
    email: 'Email',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    saving: "Saving...",
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    add: 'Add',
    back: 'Back',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    close: 'Close',
    copyright: '© 2024 SwapStop. All rights reserved.',
    dashboard: 'Dashboard',
    all: 'All',
    yes: 'Yes',
    no: 'No',
  },
  auth: {
    login: {
      title: 'Login',
      email: 'Email',
      password: 'Password',
      submit: 'Sign In',
      error: 'Invalid email or password',
    },
    changePassword: {
      title: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      submit: 'Change Password',
      success: 'Password changed successfully',
      error: 'Failed to change password',
      passwordsNotMatch: 'New passwords do not match',
    },
    forgotPassword: {
      title: 'Forgot Password',
      submit: 'Send OTP',
      success: 'OTP sent successfully',
      error: 'Failed to send OTP',
    },
    resetPassword: {
      title: 'Reset Password',
      otp: 'OTP',
      submit: 'Reset Password',
      success: 'Password reset successfully',
      error: 'Failed to reset password',
    },
  },
  users: {
    management: {
      title: 'User Management',
      searchPlaceholder: 'Search Users',
      addUser: 'Add User',
      noUsers: 'No users found',
      viewDetails: 'View Details',
      editUser: 'Edit User',
      deleteUser: 'Delete User',
      toggleStatus: 'Toggle Status',
      active: 'ACTIVE',
      inactive: 'INACTIVE',
      userDetails: 'User Details',
      all: 'All',
      toggleStatusConfirm: {
        activate: 'Are you sure you want to activate',
        deactivate: 'Are you sure you want to deactivate'
      }
    },
    fetch: {
      error: 'Failed to fetch users'
    },
    details: {
      title: 'User Details',
      name: 'Name',
      email: 'Email',
      role: 'Role',
      status: 'Status',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      close: 'Close',
    },
    edit: {
      title: 'Edit User',
    },
    delete: {
      title: 'Delete User',
      message: 'Are you sure you want to delete this user?',
      confirm: 'Are you sure you want to delete user',
      cancel: 'Cancel',
      success: 'User deleted successfully',
      error: 'Failed to delete user',
    },
    form: {
      title: 'User Form',
      name: 'Name',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      role: 'Role',
      submit: 'Save',
      cancel: 'Cancel',
      success: 'User saved successfully',
      error: 'Failed to save user',
    },
    sales: {
      title: 'Sales',
      itemName: 'Item',
      price: 'Price',
      quantity: 'Quantity',
      totalAmount: 'Total',
      saleDate: 'Sale Date',
      buyerName: 'Buyer',
      status: 'Status',
      statuses: {
        completed: 'Completed',
        pending: 'Pending',
        cancelled: 'Cancelled'
      }
    },
    purchases: {
      title: 'Purchases',
      itemName: 'Item',
      price: 'Price',
      quantity: 'Quantity',
      totalAmount: 'Total',
      purchaseDate: 'Purchase Date',
      sellerName: 'Seller',
      status: 'Status',
      statuses: {
        completed: 'Completed',
        pending: 'Pending',
        cancelled: 'Cancelled'
      }
    },
  },
  locker: {
    error: {
      fetch: 'Failed to fetch locker',
      delete: 'Failed to delete locker',
      status: 'Failed to update locker',
      create: 'Failed to create locker'
    },
    create: {
      success: 'Locker created successfully',
    },
    delete: {
      title: 'Delete Locker',
      confirmation: 'Are you sure you want to delete locker?',
      success: 'Locker deleted successfully',
    },
  },
  containers: {
    title: 'Container Management',
    error: {
      fetch: 'Failed to fetch containers',
      delete: 'Failed to delete container',
      status: 'Failed to update container status',
      create: 'Failed to create container'
    },
    delete: {
      title: 'Delete Container',
      confirmation: 'Are you sure you want to delete container "{{name}}"?',
      success: 'Container deleted successfully',
    },
    create: {
      success: 'Container created successfully',
    },
    management: {
      title: 'Container Management',
      containerId: 'Container ID',
      containerTitle: 'Title',
      location: 'Address',
      totalLockers: 'Total Lockers',
      occupiedLockers: 'Occupied Lockers',
      actions: 'Actions',
      viewDetails: 'View Details',
      addContainer: 'Add Container',
      viewContainer: 'View Container',
      editContainer: 'Edit Container',
      containerNumber: 'Container Number',
      containerName: 'Container Name',
      serialNumber: 'Serial Number',
      zipCode: 'Zip Code',
      address: 'Address',
      latitude: 'Latitude',
      longitude: 'Longitude',
      lockers: 'Lockers',
      addLocker: 'Add Locker',
      lockerId: 'Locker ID',
      uniqueId: 'Unique ID',
      chargesPerHour: 'Charges (Per Hour)',
      imeiNumber: 'IMEI Number',
      occupied: 'Occupied',
      search: ' Search'
    },
  },
  settings: {
    title: 'Settings',
    locker: {
      title: 'Locker Settings',
      ratePerHour: 'Rate Per Hour',
      minimumDuration: 'Minimum Duration To Book Locker',
      maximumDuration: 'Maximum Duration To Book Locker',
      minimumExtendDuration: 'Minimum Extended Duration To Book Locker',
      // maximumExtendDuration: 'Maximum Extend Duration To Book Locker',
      maximumResponseTime: 'Maximum Response Time (Seller & Buyer)',
      timeRemaining: 'Extend Locker Duration Before',
      hours: 'hours',
      minutes: 'minutes',
    }
  },
  profile: {
    title: 'Profile',
    changePassword: 'Change Password',
    backToDashboard: 'Back to Dashboard',
    signOut: 'Sign Out',
  },
  dashboard: {
    sections: {
      users: 'User Statistics',
      containers: 'Container Statistics',
      lockers: 'Locker Statistics',
      orders: 'Order Statistics',
      payments: 'Payment Statistics',
    },
    metrics: {
      allUsers: 'All Users',
      activeUsers: 'Active Users',
      inactiveUsers: 'Inactive Users',
      newUsers: 'New Users (30d)',
      allContainers: 'All Containers',
      activeContainers: 'Active Containers',
      inactiveContainers: 'Inactive Containers',
      occupiedContainers: 'Occupied Containers',
      allLockers: 'All Lockers',
      activeLockers: 'Active Lockers',
      inactiveLockers: 'Inactive Lockers',
      occupiedLockers: 'Occupied Lockers',
      totalOrders: 'Total Orders',
      activeOrders: 'Active Orders',
      successfulOrders: 'Successful Orders',
      failedOrders: 'Failed Orders',
      lockerCharges: 'Locker Charges',
      escrowPayments: 'Payment In Escrow',
      sellerPayments: 'Transferred To Seller',
      buyerRefunds: 'Refunded To Buyer',
    },
  },
  orders: {
    title: 'Order Management',
    not_found: 'Order not found',
    order_number: 'Order Number',
    customer_name: 'Customer Name',
    seller_name: 'Seller Name',
    item_name: 'Item Name',
    item_price: 'Item Price',
    status: 'Status',
    payment_status: 'Payment Status',
    created_at: 'Created At',
    booking_time: 'Booking Time',
    handling_time: 'Handling Time',
    duration: 'Duration',
    charges: 'Charges',
    total_charges: 'Total Charges',
    extend_time: 'Extend Time',
    extend_duration: 'Extend Duration',
    extend: 'Extend',
    cancel: 'Cancel',
    hours: 'hours',
    seller_usage: 'Seller Usage',
    buyer_usage: 'Buyer Usage',
    actions: 'Actions',
    view: 'View',
    status_pending: 'Pending',
    status_active: 'Active',
    status_completed: 'Completed',
    status_cancelled: 'Cancelled',
    payment_pending: 'Payment Pending',
    payment_paid: 'Paid',
    payment_refunded: 'Refunded',
    action: 'Action',
    extensions: 'Extensions',
    action_booking: 'Locker Booked',
    action_itemPlacement: 'Item Placed',
    action_itemPickup: 'Item Picked Up',
    action_itemReturn: 'Item Returned',
    action_itemCollection: 'Item Collected',
    rate_per_hour: 'Rate Per Hour',
    flow: {
      steps: {
        offer_sent: 'Offer Sent',
        offer_accepted: 'Offer Accepted By Buyer',
        payment_made: 'Payment Made For Offer',
        offer_created: 'Offer Created',
        payment_escrow: 'Payment in Escrow',
        locker_booked_seller: 'Locker Booked by Seller',
        seller_extended: 'Seller Extended Locker Time',
        item_placed: 'Item Placed by Seller',
        acknowledged_buyer: 'Buyer Acknowledged',
        locker_booked_buyer: 'Locker Booked by Buyer',
        buyer_extended: 'Buyer Extended Locker Time',
        item_picked: 'Item Picked by Buyer',
        buyer_confirmed: 'Buyer Confirmed',
        seller_acknowledged: 'Seller Acknowledged',
        completed: 'Transaction Completed',
        buyer_unsatisfied: 'Buyer Unsatisfied'
      },
      status: {
        pending: 'Pending',
        offer_sent: 'Offer Sent',
        offer_accepted: 'Offer Accepted',
        payment_made: 'Payment Made',
        in_escrow: 'In Escrow',
        locker_booked: 'Locker Booked',
        extended_seller: 'Extended (Seller)',
        item_stored: 'Item Stored',
        buyer_notified: 'Buyer Notified',
        buyer_booked: 'Buyer Booked',
        extended_buyer: 'Extended (Buyer)',
        in_review: 'In Review',
        completed: 'Completed',
        returned: 'Returned',
        resolved: 'Resolved',
        escalated: 'Escalated',
        buyer_unsatisfied: 'Buyer Unsatisfied'
      },
      notes: {
        offer_sent: 'Seller sent offer to buyer',
        offer_accepted: 'Buyer accepted the offer',
        payment_made: 'Buyer made payment for the offer',
        offer_created: 'Awaiting buyer\'s acceptance',
        payment_escrow: 'Payment held in escrow',
        locker_booked_seller: 'Seller selects locker, can extend multiple times before item is placed',
        seller_extended: 'Seller can extend locker duration before placing item',
        item_placed: 'Once item is placed in locker, buyer can book the locker',
        acknowledged_buyer: 'Buyer has been notified about item placement',
        locker_booked_buyer: 'Buyer books locker to pick up the item, can extend multiple times',
        buyer_extended: 'Buyer can extend locker duration before picking item',
        item_picked: 'Buyer picks up item, review/inspection phase',
        buyer_confirmed: 'Transaction completed successfully if satisfied',
        seller_acknowledged: 'Seller acknowledged the completion',
        completed: 'Escrow released to seller if buyer satisfied, or refunded if buyer returned the item',
        buyer_unsatisfied: 'Buyer was not satisfied with the item and returned it'
      }
    }
  },
  app: {
    title: 'SwapStop',
  },
  navigation: {
    dashboard: 'Dashboard',
    users: 'Users',
    containers: 'Containers',
    orders: 'Orders',
    payments: 'Payments',
    notifications: 'Notifications',
    settings: 'Settings',
    profile: 'Profile',
    changePassword: 'Change Password',
    logout: 'Logout',
  },
  notifications: {
    title: 'Notification Management',
    create: 'Add Notification',
    delete: 'Deleted Notification',
    resend: 'Resend Notification',
    id: 'ID',
    notificationTitle: 'Title',
    message: 'Message',
    lastSentDate: 'Last Sent Date',
    actions: 'Actions',
    cancel: 'Cancel',
    createButton: 'Create',
    deleteButton: 'Delete',
    resendButton: 'Resend',
    deleteConfirmation: 'Are you sure you want to delete this notification?',
    resendConfirmation: 'Are you sure you want to resend this notification?',
    error: {
      create: 'Error creating notification',
      delete: 'Error deleting notification',
      resend: 'Error resending notification'
    },
    success: {
      create: 'Notification created successfully',
    },
  },
  payments: {
    title: 'Payment Transactions',
    type: 'Payment Type',
    amount: 'Amount',
    timestamp: 'Date/Time',
    status: {
      completed: 'Completed',
      pending: 'Pending',
      failed: 'Failed'
    }
  },
};
